<!-- <div class="container">
    <div class="zoom-container">
        <div id="meetingSDKElement">
        </div>
    </div>
</div> -->
<div *ngIf="loading" class="spinner-bg">
    <div class="spinner-container">
    <img src="../assets/img/spinner_liveevent.gif" alt="">
    <span class="spinner-message">En unos minutos serás todo un experto en bienestar, tu evento está cargando.</span>
    </div>
</div>
<router-outlet></router-outlet>